<template>
  <div class="time-slot-selector">
    <div
      class="d-flex align-center"
    >
      <span
        v-if="label"
        class="subtitle-1 mr-2"
      >
        {{ label }}
      </span>
      <v-btn
        x-small
        class="mr-2"
        @click="toggle(true)"
      >
        {{ $t('common.select_all') }}
      </v-btn>
      <v-btn
        x-small
        class="mr-2"
        @click="toggle(false)"
      >
        {{ $t('common.select_none') }}
      </v-btn>
    </div>
    <div
      class="d-flex justify-space-between"
    >
      <div
        style="width:80px"
        class="d-flex flex-shrink-0"
      />
      <div
        v-for="hour in 24"
        :key="hour"
        class="d-flex flex-grow-1 justify-center"
      >
        {{ `${hour}`.padStart(2, '0') }}
      </div>
    </div>
    <div class="selection-container">
      <div
        v-for="(values, day) in state"
        :key="day"
        class="d-flex justify-space-between align-center"
      >
        <div
          style="width:80px;height: 20px;"
          class="d-flex flex-shrink-0"
        >
          {{ $t('common.' + day) }}
        </div>
        <v-sheet
          v-for="slot in 48"
          :key="slot"
          :ref="`${day}-${slot}`"
          :data-ref="`${day}-${slot}`"
          :color="values[slot - 1] ? 'success' : 'error'"
          elevation="1"
          style="border-radius: 12px;width: 12px;height: 12px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import defaults from '../../utils/timeslotsDefault';

export default {
  name: 'TimeSlotSelector',
  props: {
    label: {
      type: String,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      state: { ...this.value },
    };
  },
  watch: {
    value(val) {
      this.state = { ...val };
    },
  },
  mounted() {
    Selection.create({
      // Class for the selection-area
      class: 'selection',
      startThreshold: 2,

      // All elements in this container can be selected
      selectables: ['.selection-container .v-sheet'],

      // The container is also the boundary in this case
      boundaries: ['.selection-container'],
    }).on('start', ({ inst, selected, oe }) => {
      // Remove class if the user isn't pressing the control key or ⌘ key
      if (!oe.ctrlKey && !oe.metaKey) {
        // Unselect all elements
        // eslint-disable-next-line no-restricted-syntax
        for (const el of selected) {
          inst.removeFromSelection(el);
        }
        this.updateSelection([], [], []);

        // Clear previous selection
        inst.clearSelection();
      }
    }).on('move', ({ selected, changed: { removed, added } }) => {
      this.updateSelection(selected, added, removed);
    }).on('stop', ({ inst }) => {
      inst.keepSelection();
      this.$emit('input', this.state);
    });
  },
  methods: {
    // @TODO We might be able to remove "removed" here?
    // eslint-disable-next-line no-unused-vars
    updateSelection(selected = [], added = [], removed = []) {
      const value = defaults();
      // eslint-disable-next-line no-restricted-syntax
      for (const el of selected) {
        const [day, slot] = el.dataset.ref.split('-');
        value[day][slot - 1] = true;
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const el of added) {
        const [day, slot] = el.dataset.ref.split('-');
        value[day][slot - 1] = true;
      }
      this.state = value;
    },
    toggle(value) {
      const values = Array(48).fill(value);
      this.state = {
        monday: [...values],
        tuesday: [...values],
        wednesday: [...values],
        thursday: [...values],
        friday: [...values],
        saturday: [...values],
        sunday: [...values],
      };
      this.$emit('input', this.state);
    },
  },
};
</script>

<style>
.selection {
    background: rgba(0, 0, 0, .15);
    border: 1px solid rgba(0, 0, 0, .25);
}
.selection-container .tmp-selected {
    background-color: #4caf50 !important;
    border-color: #4caf50 !important;
}
</style>
